var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_1538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37267 32.229L0.740479 0.0601196L32.1757 0.124765L29.3924 32.229L16.5767 35.9399L3.37267 32.229Z",
    fill: "#E34F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5767 32.8331V3.12378L29.5219 3.16688L27.2134 29.7476L16.5767 32.8331Z",
    fill: "#EF652A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9622 10.5458L26.3287 6.61896H6.41479L7.51503 18.6581H21.2585L20.7196 23.793L16.3182 24.9794L11.8521 23.685L11.6148 20.6213H7.66612L8.20559 26.8782L16.3179 29.1435L24.4949 26.8782L25.5951 14.6666H11.1615L10.7516 10.5458H25.9622Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_1538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.4352,
    height: 36,
    fill: "white",
    transform: "translate(0.740479)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/HTML.250b0f15c21ee51d1ab7adfcc53e1d11.svg";
export { ForwardRef as ReactComponent };